import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import BuySMSModal from "../buysms/BuySMSModal";
import BuyRCSModal from "../buysms/BuyRCSModal";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import Loader from "../Loader/Loader";
import SMSHistoryFilterModal from "../buysms/SMSHistoryFilterModal";

const defaultFilterData = {
  vendorName: "",
  txnType: "",
  status: [],
  fromDate: "",
  toDate: "",
};

const BuySMS = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [buySMSData, setBuySMSData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [showRcsModal, setRcsShowModal] = useState(false);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const openModalFilter = () => {
    setIsFilterModalOpen(true);
  };

  const closeModalFilter = () => {
    setIsFilterModalOpen(false);
  };
  
  const handleReset = () => {
    setFilterData(defaultFilterData);
    setCurrentPage(1);
  };

  // Function to format date from "year-month-day" to "day-month-year"
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    fetchBuySMSData(1, filterData);
  }, []);

  const fetchBuySMSData = async (pageNo, filters) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        vendorName: filters.vendorName || "",
        txnType: filters.txnType || "",
        status: filters.status || [],
        fromDate: formatDate(filters.fromDate) || "",
        toDate: formatDate(filters.toDate) || "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_BUYSMS_DATA}?&pageSize=${pageSize}&pageNo=${pageNo}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setBuySMSData(modifiedData);

        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setBuySMSData([]);
        if (
          response?.data?.respCode !== "01" &&
          response?.data?.data !== null
        ) {
          CustomAlert({
            title: "Failed to Fetch Data",
            text:
              response?.data?.message ||
              "No data available for the specified criteria.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setBuySMSData([]);
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      // transactionDate: item.transactionDate?.split(" ")?.[0],
      id: index + 1,
    }));
  };

  const buySMSHeaders = [
    "Status",
    // "Vendor Id",
    "Vendor Name",
    "Transaction Id",
    "Txn Type",
    "Transaction Date",
    "Buy Sms(Qty)",
    "Old Sms Count(Qty)",
    "New Sms Count(Qty)",
    "SMS Rate",
    "Amount",
    "RCS Rate",
    "Buy Rcs",
    "Old Rcs Count(Qty)",
    "New Rcs Count(Qty)",
  ];

  const buySMSHeaderToKeyMap = {
    Status: "status",
    // "Vendor Id": "vendorId",
    "Vendor Name": "vendorName",
    "Transaction Id": "rrn",
    "Txn Type": "txnType",
    "Transaction Date": "transactionDate",
    "Buy Sms(Qty)": "sms",
    "Old Sms Count(Qty)": "vendorOldSms",
    "New Sms Count(Qty)": "vendorNewSms",
    "SMS Rate": "rate",
    Amount: "amount",
    "RCS Rate": "rcsRate",
    "Buy Rcs": "rcsBalance",
    "Old Rcs Count(Qty)": "vendorOldRcs",
    "New Rcs Count(Qty)": "vendorNewRcs",
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
    setRcsShowModal(false);
  };

  const handlerBuySMS = (id, actionType = "view") => {
    setModalAction(actionType);
    console.log(
      "kkkkkkkkkkk::",
      buySMSData.find((item) => item.id === id)
    );
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else if (actionType === "rcs") {
      setEditData({});
      setRcsShowModal(true);
    } else {
      let data = buySMSData.find((item) => item.id === id);
      setEditData(data);
      setShowModal(true);
      setRcsShowModal(true);
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading && <Loader />}
      <MasterTable
        headers={buySMSHeaders}
        data={buySMSData}
        handleAction={handlerBuySMS}
        filterFields={["vendorName"]}
        entityType="Buy SMS"
        headerToKeyMap={buySMSHeaderToKeyMap}
        loading={loading}
        noData={noData}
        pageDetails={pageDetails}
        currentPage={currentPage}
        pageSize={pageSizeCount}
        totalRecord={totalRecord}
        handleReset={handleReset}
        // fetchNextData={fetchBuySMSData}
        setCurrentPage={setCurrentPage}
        fetchNextData={(pageNo) => fetchBuySMSData(pageNo, filterData)}
        filterData={filterData}
        // setCurrentPage={setCurrentPage}
        openModalFilter={openModalFilter}
        fetchData={() => fetchBuySMSData(1, defaultFilterData)}
      />
      {isFilterModalOpen && (
        <SMSHistoryFilterModal
          show={isFilterModalOpen}
          handleClose={closeModalFilter}
          setFilterData={setFilterData}
          filterData={filterData}
          handleReset={handleReset}
          setBuySMSData={setBuySMSData}
          setPageDetails={setPageDetails}
          setNoData={setNoData}
          currentPage={currentPage}
          pageSize={pageSizeCount}
        />
      )}

      <BuySMSModal
        show={showModal}
        handleClose={handleCloseModal}
        editData={editData}
        action={modalAction}
        data={buySMSData}
        fetchData={fetchBuySMSData}
      />
      <BuyRCSModal
        show={showRcsModal}
        handleClose={handleCloseModal}
        editData={editData}
        action={modalAction}
        data={buySMSData}
        fetchData={fetchBuySMSData}
      />
    </div>
  );
};

export default BuySMS;